<app-page>
  <nft-post></nft-post>
</app-page>
